export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8905.204a9187.jpg";